import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material';
import {FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {ApplyButton, ListGridContainer, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants'
import {BreakPcOnly, DisplayItemInputTitleNoMargin} from '../../../../../styledComponents/DisplayItem'
import {StyledSecondaryButton} from '../../../../../styledComponents/Button'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import {Location} from 'react-router-dom'
import {NatResidentCondominiumSelectDialog} from '../../../common/resident/NatResidentCondominiumSelectDialog'

interface Props {
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType
    location: Location
    submitButtonLabel: string
    onClickRegisterConfirmButton: (
        condominiumCd: string,
        mailAddress: string,
        mailAddressConfirm: string
    ) => Promise<void>
}

interface State {
    condominiumCd: string
    condominiumName: string
    mailAddress: string
    mailAddressConfirm: string
    isDialogOpen: boolean
    applyButtonDisabled: boolean
}

export default class NatResidentCondominiumRegisterForm extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            condominiumCd: '',
            condominiumName: '',
            mailAddress: '',
            mailAddressConfirm: '',
            isDialogOpen: false,
            applyButtonDisabled: true,
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.onClickDialogOpen = this.onClickDialogOpen.bind(this)
        this.onClickDialogClose = this.onClickDialogClose.bind(this)
        this.onClickCondominiumSelect = this.onClickCondominiumSelect.bind(this)
        this.onClickRegisterConfirmButton = this.onClickRegisterConfirmButton.bind(this)
    }


    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value ? value : null}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            condominiumCd, mailAddress, mailAddressConfirm
        } = this.state

        let applyButtonDisabled = false
        if (!condominiumCd || !mailAddress || !mailAddressConfirm) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    onClickDialogOpen(): void {
        this.setState({isDialogOpen: true})
    }

    onClickDialogClose(): void {
        this.setState({isDialogOpen: false})
    }

    onClickCondominiumSelect(condominiumCd: string, condominiumName: string): void {
        this.setState({
            condominiumCd: condominiumCd,
            condominiumName: condominiumName,
            isDialogOpen: false
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async onClickRegisterConfirmButton(): Promise<void> {
        const {condominiumCd, mailAddress, mailAddressConfirm} = this.state
        await this.props.onClickRegisterConfirmButton(condominiumCd, mailAddress, mailAddressConfirm)
    }

    renderApplicantForm(): ReactElement {
        const {condominiumName, mailAddress, mailAddressConfirm} = this.state

        return (
            <>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'マンション名'}
                        required
                        component={
                            <CondominiumSelectButton onClick={this.onClickDialogOpen}>
                                <FullWidthColumnFlexContainer>選択する</FullWidthColumnFlexContainer>
                            </CondominiumSelectButton>
                        }
                    />
                    {condominiumName && <NatResidentApplicationDetailFormItem
                        title={''}
                        component={condominiumName}
                    />
                    }
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'メールアドレス'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'mailAddress',
                                    maxLength: 100,
                                    value: mailAddress,
                                    onChange: this.handleChangeText,
                                    placeholder: '例：mail@example.com'
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['mailAddress']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'5px'}/>
                    <Box fontSize={FontSize.Middle}>
                        ※ご入力いただいたメールアドレスは、素敵ネットユーザ登録完了後、素敵ネットにログインする際に必要となります
                    </Box>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>メールアドレス<BreakPcOnly/>（確認用）</span>}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'mailAddressConfirm',
                                    maxLength: 100,
                                    value: mailAddressConfirm,
                                    onChange: this.handleChangeText,
                                    placeholder: '例：mail@example.com'
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['mailAddressConfirm']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <Box fontWeight={FontWeights.Bold}>【注意事項】</Box>
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <Box>・</Box>
                        <DisplayItemInputTitleNoMargin>
                            <Box component={'span'} color={Colors.Body}>
                                メールが届かない場合は、ご契約のプロバイダやメールソフトの設定などにより、受信ができない可能性がございます。
                            </Box>
                        </DisplayItemInputTitleNoMargin>
                        <Box>・</Box>
                        <DisplayItemInputTitleNoMargin>
                            <Box component={'span'} color={Colors.Body}>
                                迷惑メールの対策で、ドメイン受信設定を行っている場合は、「@suteki.haseko.jp」「@haseko.co.jp」を受信設定してください。
                                設定方法はご契約のプロバイダのWebサイトをご確認ください。
                            </Box>
                        </DisplayItemInputTitleNoMargin>
                        <Box>・</Box>
                        <DisplayItemInputTitleNoMargin>
                            <Box component={'span'} color={Colors.Body}>
                                yahooメール/gmail等のフリーメールアドレスでもご登録いただけます。スマートフォンをご利用のお客様でも、
                                SMSにて受信するメールアドレスをご利用の方は、確認メールが正しく表示されず、ご登録いただけませんので、ご注意ください。
                            </Box>
                        </DisplayItemInputTitleNoMargin>
                    </ListGridContainer>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {isDialogOpen, applyButtonDisabled} = this.state

        return (
            <>
                <NatResidentCondominiumSelectDialog
                    isDialogOpen={isDialogOpen}
                    condominiumRepo={this.props.condominiumRepo}
                    eventEmitter={this.props.eventEmitter}
                    asyncCallFunction={this.props.asyncCallFunction}
                    onClose={this.onClickDialogClose}
                    onClickCondominiumSelect={this.onClickCondominiumSelect}
                />
                {this.renderApplicantForm()}
                <Box height={'15px'}/>
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickRegisterConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        {submitButtonLabel}
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const CondominiumSelectButton = styled(StyledSecondaryButton)`
    display: flex;
    align-items: center;
    margin: 0 0 15px;
`

